angular.module('capability-ng-global').config(function($httpProvider: ng.IHttpProvider) {
  $httpProvider.interceptors.push(function(sessionTimerDelegate): ng.IHttpInterceptor {
    const IS_RESOURCE_REQUEST = /\.\w{3,4}$/i;
    const userSessionDelegate = sessionTimerDelegate.handle('userSession');

    return {
      request: function(config: ng.IRequestConfig) {
        const hasExtension = IS_RESOURCE_REQUEST.test(config.url);
        const isAnAPIRequest = !hasExtension;
        if (isAnAPIRequest) {
          userSessionDelegate.restartSession();
        }
        return config;
      }
    };
  });
});



// WEBPACK FOOTER //
// ./app/lib/global/configuration/session_timeout_interceptor.ts